import { RequireAtLeastOne } from '../utils/types';

export type UniqueUserKey = RequireAtLeastOne<{
  id: string;
  email: string;
  and: { phoneNumber: string; countryCode?: string };
}>;

export enum Gender {
  M = 'M',
  F = 'F',
  O = 'O'
}

export enum Occupation {
  STUDENT = 'STUDENT',
  WORKING_PROFESSIONAL = 'WORKING_PROFESSIONAL',
  ENTERPRENEUR = 'ENTERPRENEUR',
  HOMEMAKER = 'HOMEMAKER',
  OTHER = 'OTHER'
}

export enum MaritalStatus {
  MARRIED = 'MARRIED',
  UNMARRIED = 'UNMARRIED'
}

export type Xplos = {
  id?: string;
  fullName: string;
  email: string;
  phoneNumber: string;
  countryCode?: string;
} & Partial<AdditionalFields>;

export enum FieldName {
  dob = 'dob',
  gender = 'gender',
  city = 'city',
  occupation = 'occupation',
  maritalStatus = 'maritalStatus'
}

export interface AdditionalFields {
  [FieldName.dob]: Date;
  [FieldName.gender]: Gender;
  [FieldName.city]: string;
  [FieldName.occupation]: Occupation;
  [FieldName.maritalStatus]: MaritalStatus;
}

export const FIELD_DETAILS: Record<FieldName, { displayName: string }> = {
  [FieldName.dob]: {
    displayName: 'Date Of Birth'
  },
  [FieldName.gender]: {
    displayName: 'Gender'
  },
  [FieldName.city]: {
    displayName: 'City'
  },
  [FieldName.occupation]: {
    displayName: 'Occupation'
  },
  [FieldName.maritalStatus]: {
    displayName: 'Marital Status'
  }
};
